module.exports = __webpack_public_path__ + "img/图标背景-active.b27ed803.svg";